import React, { useCallback } from 'react';
import styled from 'styled-components';

import { usePlayer } from '../../../contexts/PlayerContext';
import './BasketToggle.scss';

const Container = styled.div`
	display: flex;
	justify-content: center;
	margin: 0;
	margin-left: auto;
	margin-right: auto;
	pointer-events: all;

	@media screen and (max-width: 992px) and (orientation: portrait) and (hover: none) and (pointer: coarse) {
		padding: 10% !important;
		height: 4vh !important;
		min-height: 40px !important;
		width: 4vh !important;
		min-width: 40px !important;
	}
`;

interface BasketIconProps {
    count: number;
    color?: string;
}

const BasketIcon: React.FC<BasketIconProps> = ({ count, color }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
        <g id="Group_8025" data-name="Group 8025" transform="translate(0.21 0.11)">
            <rect id="Rectangle_63" data-name="Rectangle 63" width="34" height="34" rx="4" transform="translate(-0.21 -0.11)" />
            <path
                id="shopping_cart_buy_commerce"
                data-name="shopping, cart, buy, commerce"
                d="M18.332,20.881H9.954l-.145-1.088h9.249a.363.363,0,0,0,.363-.308l1.088-6.892a.326.326,0,0,0-.091-.29.381.381,0,0,0-.272-.127H8.793l-.254-1.868A.363.363,0,0,0,8.176,10H6.363a.363.363,0,1,0,0,.725H7.85L9.228,20.954a1.415,1.415,0,0,0-1.052,1.378,1.451,1.451,0,0,0,2.9,0,1.4,1.4,0,0,0-.2-.725h6.2a1.4,1.4,0,0,0-.2.725,1.451,1.451,0,1,0,1.451-1.451Z"
                transform="translate(3.533 -0.001)"
                fill="#fff"
            />
            <g id="Group_8015" data-name="Group 8015" transform="translate(-1201.425 -595.518)">
                <rect
                    id="Rectangle_8712"
                    data-name="Rectangle 8712"
                    width="16.121"
                    height="17"
                    rx="8.061"
                    transform="translate(1219.093 596)"
                    fill={color ?? '#126cfc'}
                />
                <text
                    id="_2"
                    data-name="2"
                    transform="translate(1227.154 609)"
                    fill="#fff"
                    fontSize="12"
                    fontFamily="inherit"
                    fontWeight="500"
                    letterSpacing="0.02em"
                >
                    <tspan x="-3" y="0">
                        {count}
                    </tspan>
                </text>
            </g>
        </g>
    </svg>
);

interface BasketToggleProps {
    color?: string;
    basketItemCount: number;
}

const BasketToggle: React.FC<BasketToggleProps> = (props) => {
    const { showShoppingCart, setShowShoppingCart } = usePlayer();

    const handleClickOnBasket = useCallback(() => {
        setShowShoppingCart(!showShoppingCart);
    }, [showShoppingCart, setShowShoppingCart]);

    return (
        <Container onClick={handleClickOnBasket}>
            <BasketIcon color={props.color} count={props.basketItemCount} />
        </Container>
    );
};

export default BasketToggle;
